<template>
  <div class="cloze">
      <!-- 小题题干 -->
      <p :class="[myColor?'inspect_myColor':'article']" v-html="$options.filters.strReplace(ask.subject.content,'\#\#','或')" v-if="ask.subject.content"></p>
      <!-- 小题题干图片 -->
      <div class="cont_img" v-for="(img) in ask.subject.images" v-if="ask.subject.images">
        <img :src="img" alt=""/>
      </div>
  </div>
</template>

<script type="text/ecmascript-6">

  export default {
    data() {
      return {}
    },
    //ask:小题数据
    props: ['ask','myColor'],
    components: {},
    methods: {},
    created() {

    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "./src/assets/scss/common/_mixin";

  .cloze {
    font-size: 30px/$ppr;
    color: #333;
    .article {
      padding: 34px/$ppr 24px/$ppr;
      border-top: 1px/$ppr solid #dcdcdc;
    }
    .inspect_myColor{
      padding: 34px/$ppr 24px/$ppr;
      border-top: 1px/$ppr solid #dcdcdc;
    }
  }
</style>
